import { linkToLogin } from "$routes/user/links";
import { useApolloClient } from "@apollo/client";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";

export const SignOut: FC = () => {
  const apolloClient = useApolloClient();

  const { isAuthenticated, logout } = useAuth0();

  useEffect(() => {
    sessionStorage.clear();
    apolloClient.clearStore();

    if (isAuthenticated) {
      logout({ returnTo: `${window.location.origin}${linkToLogin()}` });
    }
  }, [apolloClient, isAuthenticated, logout]);

  return <Navigate to={linkToLogin()} />;
};
